/*
  Peça avulsa abre sem tamanho marcado.

  O tema marca o primeiro tamanho disponível (P) quando a página abre, e quem não
  repara compra P. Na página do conjunto nada vem marcado; aqui vale o mesmo: o
  botão fica desligado com "Escolha o tamanho" até a cliente tocar num tamanho.

  - Página aberta com ?variant= (link direto para um tamanho) segue marcada.
  - Depois da primeira escolha o tema redesenha o bloco com o tamanho certo e
    o botão ligado; o produto entra na lista de escolhidos e não é mais mexido.
  - Vale também para a escolha rápida da vitrine (quick-add), que usa o mesmo bloco.
  - Conjunto (bloco próprio de tamanhos) e produto de tamanho único ficam de fora.
*/
(function () {
  var escolhidos = new Set();
  /* Configurações do tema > TDS · Textos da loja */
  var TEXTO = (window.tdsTextos && window.tdsTextos.escolhaTamanho) || 'Escolha o tamanho';

  function temVariantNaUrl() {
    return /[?&]variant=/.test(window.location.search);
  }

  function preparar(info) {
    if (!info || info.dataset.tdsTamanhoPronto) return;
    info.dataset.tdsTamanhoPronto = '1';

    var id = info.dataset.productId;
    if (!id || escolhidos.has(id)) return;
    if (info.querySelector('[data-tds-conjunto]')) return;

    var seletor = info.querySelector('variant-selects');
    if (!seletor) return;
    var radios = seletor.querySelectorAll('input[type="radio"]');
    if (radios.length < 2) return;

    /* Na página do produto, um link com ?variant= já é uma escolha. Na escolha
       rápida (modal) o endereço é da vitrine, então sempre começa sem marcação. */
    var ehPaginaDoProduto = !info.closest('quick-add-modal');
    if (ehPaginaDoProduto && temVariantNaUrl()) {
      escolhidos.add(id);
      return;
    }

    radios.forEach(function (r) {
      r.checked = false;
    });
    info.classList.add('tds-sem-tamanho');

    var botao = info.querySelector('product-form button[name="add"]');
    if (botao) {
      botao.disabled = true;
      var rotulo = botao.querySelector('span') || botao;
      rotulo.textContent = TEXTO;
    }
  }

  function varrer(raiz) {
    (raiz || document).querySelectorAll('product-info').forEach(preparar);
  }

  /* Captura: registra a escolha antes de o tema redesenhar o bloco. */
  document.addEventListener(
    'change',
    function (evento) {
      var alvo = evento.target;
      if (!alvo || !alvo.closest || !alvo.closest('variant-selects')) return;
      var info = alvo.closest('product-info');
      if (!info) return;
      escolhidos.add(info.dataset.productId);
      info.classList.remove('tds-sem-tamanho');
    },
    true
  );

  /* Tamanho escolhido de novo depois de um redesenho: o bloco novo chega pronto. */
  if ('MutationObserver' in window) {
    new MutationObserver(function (mudancas) {
      mudancas.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('product-info')) preparar(n);
          else if (n.querySelectorAll) varrer(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.TdsTamanho = {
    semEscolha: function (info) {
      return !!(info && info.classList.contains('tds-sem-tamanho'));
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { varrer(); });
  else varrer();
})();
